// enduranceMetrics — the single source of truth for how each endurance metric
// is spelled out vs. abbreviated.
//
// Learnable-jargon rule (locked Jul 2026, founder direction): the big session
// card (under the hero image) spells a term out in FULL the first time the user
// meets it ("Strokes Per Minute"); the small selection cards below abbreviate it
// ("spm"). No modals, no toasts, no glossary popovers — the full form teaches,
// the abbreviation is the shorthand once learned. <IntervalList compact> drives
// which form renders.
//
// `cadenceUnit` on an interval is one of the keys below (strokes | strides |
// rev). Rowing = strokes, elliptical = strides, bike = rev. `split` and
// `pace100` are the pace notations for the erg and the pool; `level` is machine
// resistance.

export const METRIC_TERMS = {
  strokes: { full: 'Strokes Per Minute', abbr: 'spm' },
  strides: { full: 'Strides Per Minute', abbr: 'spm' },
  rev: { full: 'Revolutions Per Minute', abbr: 'rpm' },
  split: { full: 'split · per 500 m', abbr: '/500m' },
  pace100: { full: 'pace · per 100 m', abbr: '/100m' },
  level: { full: 'Resistance Level', abbr: 'Lvl' },
};

export const CADENCE_UNITS = ['strokes', 'strides', 'rev'];
